var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"auth"}},[(_vm.login)?_c('login',{on:{"changeview":function($event){_vm.login = false}}}):_c('register',{on:{"changeview":function($event){_vm.login = true}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }